import { Reveal } from "@/components/okaia/Reveal";

export const Founder = () => (
  <section id="fondateur" data-testid="section-fondateur" className="bg-[#F9F8F6] py-16 md:py-24">
    <div className="mx-auto max-w-[1400px] px-6 md:px-12">
      <div className="grid items-center gap-12 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Reveal>
            <img
              src="/founder.jpg"
              alt="Léandre GUYE, fondateur d'OKAÏA Dév"
              data-testid="founder-photo"
              className="w-full max-w-sm border border-[#C8A97E]/50"
            />
          </Reveal>
        </div>
        <div className="lg:col-span-7 lg:col-start-6">
          <Reveal delay={0.1}>
            <p className="okaia-overline mb-6 text-[#B39265]">Chapitre 04 — Le fondateur</p>
            <h2 className="font-serif-display text-4xl leading-[1.1] tracking-tight text-[#0B2215] md:text-5xl">
              Léandre GUYE — Fondateur d'OKAÏA&nbsp;Dév
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-8 max-w-2xl text-base font-light leading-relaxed text-[#4A5A52] md:text-lg">
              Fort de plus de 30 ans d'expérience dans le commerce et la relation client,
              Léandre met à votre service son écoute, sa pratique de la relation client et sa
              capacité à clarifier les besoins pour choisir les prochaines actions. Il
              accompagne les porteurs de projet, indépendants et entrepreneurs qui ont besoin
              de prendre du recul et de choisir une direction adaptée à leur situation.
            </p>
            <div className="mt-10 flex items-baseline gap-4">
              <span className="font-serif-display text-6xl font-medium italic text-[#C8A97E] md:text-7xl">30</span>
              <span className="max-w-[220px] text-sm font-light leading-snug text-[#4A5A52]">
                ans d'expérience dans le commerce et la relation client
              </span>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
